import { CloudOff } from 'lucide-react';
import { useRouteError } from 'react-router-dom';
import { useTheme } from '@/helpers/theme';

const ErrorFallback = ({ error: outsideError }) => {
  useTheme();

  const error = useRouteError();
  console.error(error);
  if (outsideError) {
    console.log('there was an error above react router: ', outsideError);
  }
  let message = 'Refresh the page to Try Again.';
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <CloudOff size={64} className="mb-12" />
      <h1 className="text-xl font-bold mb-2">Oops! Something went wrong</h1>
      <p className="mb-2">Don&apos;t worry, it&apos;s not you, it&apos;s us!</p>
      <p className="mb-2">{message}</p>
    </div>
  );
};

export default ErrorFallback;
